import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  const scrollToHandler = (e: React.MouseEvent, anchorElement: HTMLElement | null) => {
    e.preventDefault();

    if (anchorElement) {
      anchorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Digital Tools', href: '/digital-tools' },
            { title: 'Cargoes Flow', href: '' },
          ]}
        />

        <div className={cn('header__content')}>
          <div className={cn('header__title-box')}>
            <span className={cn('header__label')}>Digital Freight Alliance</span>

            <h1 className={cn('header__title')}>Cargoes Flow</h1>

            <p className={cn('header__title-description')}>
              The container tracking tool that tracks ocean shipments across 100s of shipping lines, all in one easy to
              use interface. See the status of your shipments in real time.
            </p>

            <div className={cn('header__buttons')}>
              <Link
                href="#what-is"
                className={cn('header__button-more')}
                onClick={(e) => scrollToHandler(e, document.querySelector('#about'))}
              >
                Learn more
              </Link>
              <Link
                href="#form"
                className={cn('header__button-request')}
                onClick={(e) => scrollToHandler(e, document.querySelector('#form'))}
              >
                Request a Demo
                <svg viewBox="0 0 10 10" aria-hidden="true">
                  <path d="M1 5h7" />
                  <path d="M2 1l4 4-4 4" />
                </svg>
              </Link>
            </div>
          </div>

          <div className={cn('header__image-box')}>
            <img
              className={cn('header__image')}
              src="/images/pages/DigitalTools/CargoesFlow/ship.png"
              alt="Cargoes Flow"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;
